import { QueryClient } from "@tanstack/react-query";

/**
 * Global react-query client. Tuned for a data-heavy dashboard at scale:
 * - staleTime 30s → dedup rapid re-fetches (multiple components asking for
 *   /dreams within 30s hit the cache, not the network).
 * - gcTime 5m → keep data around for back/forward navigation.
 * - retry 1 on network flakes; retryOnMount off to avoid thundering herds on
 *   dashboards that mount N widgets at once.
 * - refetchOnWindowFocus off — annoying at scale, no product value.
 */
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 30 * 1000,
            gcTime: 5 * 60 * 1000,
            retry: 1,
            retryOnMount: false,
            refetchOnWindowFocus: false,
        },
        mutations: {
            retry: 0,
        },
    },
});
